import React from 'react';
import { Shield, Lock, CheckCircle, Award } from 'lucide-react';

const SecurityBadges = () => {
  return (
    <section className="py-8 bg-gray-100 border-y border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12">
          {/* SSL Secure */}
          <div className="flex items-center gap-2 text-gray-600">
            <div className="w-10 h-10 bg-red-50 rounded-full flex items-center justify-center">
              <Lock size={20} className="text-red-600" />
            </div>
            <div>
              <p className="font-semibold text-gray-800 text-sm">SSL Secure</p>
              <p className="text-xs text-gray-500">256-bit Encryption</p>
            </div>
          </div>
          
          {/* Privacy Protected */}
          <div className="flex items-center gap-2 text-gray-600">
            <div className="w-10 h-10 bg-red-50 rounded-full flex items-center justify-center">
              <Shield size={20} className="text-red-600" />
            </div>
            <div>
              <p className="font-semibold text-gray-800 text-sm">Privacy Protected</p>
              <p className="text-xs text-gray-500">Your data is safe</p>
            </div>
          </div>
          
          {/* Verified Business */}
          <div className="flex items-center gap-2 text-gray-600">
            <div className="w-10 h-10 bg-red-50 rounded-full flex items-center justify-center">
              <CheckCircle size={20} className="text-red-600" />
            </div>
            <div>
              <p className="font-semibold text-gray-800 text-sm">Verified Business</p>
              <p className="text-xs text-gray-500">Licensed Dealer</p>
            </div>
          </div>
          
          {/* Trusted */}
          <div className="flex items-center gap-2 text-gray-600">
            <div className="w-10 h-10 bg-red-50 rounded-full flex items-center justify-center">
              <Award size={20} className="text-red-600" />
            </div>
            <div>
              <p className="font-semibold text-gray-800 text-sm">Trusted Since 2010</p>
              <p className="text-xs text-gray-500">5000+ Happy Customers</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SecurityBadges;
